module.exports = __webpack_public_path__ + "static/img/banner-02.4f4bd3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-02.jpg
// module id = ZLes
// module chunks = 1